export default "__VITE_ASSET__LrshInfV__"